<h1 mat-dialog-title>
  <span>{{ dialogTitle }}</span>
  <mat-icon mat-dialog-close class="alc-cursor-pointer">close</mat-icon>
</h1>
<mat-dialog-content>
  <app-report-edition-details [report]="report" [isCreation]="isCreation"></app-report-edition-details>
  <app-report-edition-form
    [report]="report"
    [isCreation]="isCreation"
    [clickedSave]="clickedSave"
    (formValid)="changeFormValidation($event)"></app-report-edition-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-raised-button
    type="button"
    color="primary"
    [disabled]="!isFormValid"
    (click)="saveForm()"
    aria-label="save">
    <span translate="save"></span>
  </button>
  <button mat-raised-button type="button" mat-dialog-close aria-label="cancel"><span translate="cancel"></span></button>
</mat-dialog-actions>
